import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { resolveFeedOptionConfigForInspectedElement } from "%/dynamic-component-editor/constants/feed-options";
import SmartFeedSelection from "%/dynamic-component-editor/options/smart-feed-selection";

export default class SmartFeedCardLayout extends BaseOption {
  static userInterfaceComponent = optionValues => {

    if (!optionValues) {
      return {
        label: "Card Layout",
        component: inspectorTools.SIMPLE_PICKER,
        props: {
          options: [],
        },
      };
    }

    const smartFeedSelection = new SmartFeedSelection().getValueFromConfiguration(optionValues);
    const config = resolveFeedOptionConfigForInspectedElement(smartFeedSelection);

    if (!config) {
      return {
        label: "Card Layout",
        component: inspectorTools.SIMPLE_PICKER,
        props: {
          options: [],
        },
      };
    }

    const variantOptions = Object.keys(config.variants).map(variant => {
      return {
        id: variant,
        name: camelToTitleCase(variant, true),
      };
    });

    return {
      label: "Card Layout",
      component: inspectorTools.SIMPLE_PICKER,
      props: {
        options: variantOptions,
      },
    };
  };

  static defaultValue = "small";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "cardSmall") {
      return "small";
    }
    if (configValue === "cardLarge") {
      return "large";
    }

    return configValue;
  }
}
